<kendo-uploaddropzone
   zoneId="attachmentsZone"
   class="drop-zone"
   (dragenter)="enableHovered($event)"
   (dragleave)="disableHovered()"
   (drop)="onDrop($event)"
>
   <ng-container *ngIf="attachments.length > 0 && !(dropZoneHovered$ | async); then attachmentList; else idleList">
   </ng-container>
</kendo-uploaddropzone>

<ng-template #idleList style="width: 100%">
   <div class="container border-box" [ngClass]="(dropZoneHovered$ | async) ? 'drop-zone-hover' : 'drop-zone-no-hover'">
      <ng-container *ngTemplateOutlet="uploadButton"> </ng-container>
      <div
         class="sam-center"
         style="width: 100%"
         [ngClass]="(dropZoneHovered$ | async) ? 'button-hover' : 'button-no-hover'"
      >
         {{ 'samwin.email_dialog.message_dropzone' | translate }}
      </div>
   </div>
</ng-template>

<ng-template #attachmentList style="width: 100%">
   <div
      class="container border-box"
      [ngClass]="(dropZoneHovered$ | async) ? 'drop-zone-hover' : 'drop-zone-no-hover'"
      [ngClass]="isInvalid ? 'k-block k-bg-warning' : ''"
   >
      <ng-container *ngTemplateOutlet="uploadButton"> </ng-container>
      <div class="attachment-container">
         <span
            *ngFor="let attachment of attachments; let i = index"
            [style]="{
               'max-width':
                  'calc(100% / ' +
                  (attachments.length < attachmentDisplayLimit ? attachments.length : attachmentDisplayLimit) +
                  ')'
            }"
         >
            <samweb-attachment-item
               *ngIf="i < attachmentDisplayLimit"
               [overlayIcon]="clearIcon"
               [attachment]="attachment"
               [messageId]="messageId"
               (click)="deleteAttachment($event)"
            >
            </samweb-attachment-item>
         </span>
      </div>
      <ng-container *ngIf="attachments.length > attachmentDisplayLimit">
         <button kendoButton look="flat" #attachmentExpandButton (click)="openAttachmentDialog()">
            {{ '+' + (attachments.length - attachmentDisplayLimit) }}
         </button>

         <kendo-popup
            *ngIf="displayOtherAttachments"
            class="popup"
            [anchor]="attachmentExpandButton"
            [anchorAlign]="{ horizontal: 'right', vertical: 'bottom' }"
            [popupAlign]="{ horizontal: 'right', vertical: 'top' }"
            (samwebOutsideClick)="closeAttachmentDialog()"
         >
            <div class="popup-item" *ngFor="let attachment of attachments; let i = index">
               <samweb-attachment-item
                  *ngIf="i >= attachmentDisplayLimit"
                  [overlayIcon]="clearIcon"
                  [attachment]="attachment"
                  [messageId]="messageId"
                  (click)="deleteAttachment($event)"
               >
               </samweb-attachment-item>
            </div>
         </kendo-popup>
      </ng-container>
      <button
         *ngIf="attachments.length > 0"
         kendoButton
         look="flat"
         (click)="removeAttachments()"
         kendoTooltip
         title="{{ 'messages_actions.remove_attachments' | translate }}"
      >
         <fa-icon [fixedWidth]="true" class="sam-center download-icon sam-red" [icon]="deleteIcon"></fa-icon>
      </button>
   </div>
</ng-template>

<ng-template #uploadButton>
   <button
      kendoButton
      look="flat"
      (click)="onUploadButtonClick(upload)"
      class="upload-button"
      [ngClass]="(dropZoneHovered$ | async) ? 'button-hover' : 'button-no-hover'"
   >
      <fa-icon [fixedWidth]="true" class="sam-center download-icon" [icon]="uploadIcon"></fa-icon>
   </button>
</ng-template>

<!-- is used for button and dropzone event, shouldn't be displayed -->
<kendo-upload
   #upload
   style="display: none"
   (select)="onSelect($event)"
   (remove)="onRemove($event)"
   zoneId="attachmentsZone"
   (cancel)="onCancel()"
>
   <kendo-fileselect-messages dropFilesHere="Drop your file here" select="Upload file"> </kendo-fileselect-messages>
</kendo-upload>
